export enum EmployeeSalaryLoanStatus {
Pending,
Approved,
Canceled,
}
